import { Component, EventEmitter, Input, Output } from '@angular/core';
import { SkeletonModule } from 'primeng/skeleton';
import { DatePipe } from '@angular/common';
import { ButtonModule } from 'primeng/button';
import { TAGEvent } from '../../../models/tagevent';
import { MatIcon } from "../mat-icon/mat-icon";

@Component({
  selector: 'event-item',
  imports: [
    SkeletonModule,
    DatePipe,
    ButtonModule,
    MatIcon
],
  providers: [],
  templateUrl: './event-listitem.component.html',
  styleUrl: './event-listitem.component.scss',
})
export class EventListitemComponent {
  @Input() event: TAGEvent;
  @Input() location: string;
  @Input() loading: boolean = false;
  @Output() eventClicked = new EventEmitter();

  constructor() {}

  ngOnInit(): void {}

  buttonClicked() {
    this.eventClicked.emit();
  }
}
